import { render, staticRenderFns } from "./ClientHistorySearch.vue?vue&type=template&id=3bd3b67c"
import script from "./ClientHistorySearch.vue?vue&type=script&lang=js"
export * from "./ClientHistorySearch.vue?vue&type=script&lang=js"
import style0 from "./ClientHistorySearch.vue?vue&type=style&index=0&id=3bd3b67c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports